import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import { CartProvider } from './state/cart.store';
import { ToastProvider } from './components/Toast';
import LockScreen from './components/LockScreen';
import ShopStatusGate from './components/ShopStatusGate';
import Home from './components/Home';
import CategoryPage from './components/CategoryPage';
import ProductPage from './components/ProductPage';

const App: React.FC = () => {
    return (
        <ToastProvider>
            <LockScreen>
                <ShopStatusGate>
                <CartProvider>
                    <Router>
                        <div className="container">
                            <h1>Pasta Fresca & Regionali</h1>
                            <Switch>
                                <Route path="/" exact component={Home} />
                                <Route path="/category/:slug" component={CategoryPage} />
                                <Route path="/product/:groupSlug" component={ProductPage} />
                                <Route path="/cart" component={Cart} />
                                <Route path="/checkout" component={Checkout} />
                            </Switch>
                        </div>
                    </Router>
                </CartProvider>
                </ShopStatusGate>
            </LockScreen>
        </ToastProvider>
    );
};

export default App;